<script>
  import { Bar, mixins } from 'vue-chartjs'
  const { reactiveProp } = mixins
  export default {
    extends: Bar,
    mixins: [reactiveProp],
    name: 'BarChart',
    props:['chartData'],
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }],
            xAxes: [ {
              gridLines: {
                display: false,
              },
              ticks: {
                //fontColor: "white",
                stepSize: 1,
                beginAtZero: true
              }
            }]
          },
          legend: {
            // display: true,
            // legend: {
            //   labels: {
            //     // This more specific font property overrides the global property
            //     fontColor: 'white'
            //   }
            // }
          },
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>
